module.exports = {
  setPerms: {
    PUBLIC: 0,
    GUEST: 1,
    MANAGER: 2,
    MEMBER: 4,
    ADMIN: 8,

    SETTINGS: 32,
    EMAIL: 64,
    ALERTS: 128,
    RENTALS: 256,
    VIOLATIONS: 512,
    DUES: 1024,
    PAYMENTS: 2048,
    PROPERTIES: 4096,
    USERS: 8192,
  },
}
